var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 9.18512C17.0002 8.49995 16.9446 7.99995 16.8243 7.48145H9.00024V10.574H13.5928C13.5002 11.3425 13.0002 12.4999 11.8891 13.2777L11.8735 13.3812L14.3473 15.2976L14.5187 15.3147C16.0928 13.861 17.0002 11.7221 17.0002 9.18512Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00013 17.3334C11.2501 17.3334 13.139 16.5926 14.5186 15.3149L11.889 13.2778C11.1853 13.7685 10.2408 14.1111 9.00013 14.1111C6.79644 14.1111 4.92608 12.6575 4.25935 10.6482L4.16163 10.6565L1.5893 12.6472L1.55566 12.7408C2.92602 15.463 5.74084 17.3334 9.00013 17.3334Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25916 10.6479C4.08324 10.1294 3.98143 9.57383 3.98143 8.99979C3.98143 8.42569 4.08324 7.87016 4.24991 7.35165L4.24525 7.24122L1.6407 5.21851L1.55549 5.25904C0.990702 6.38868 0.666626 7.65721 0.666626 8.99979C0.666626 10.3424 0.990702 11.6108 1.55549 12.7405L4.25916 10.6479Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 3.88893C10.5649 3.88893 11.6204 4.56485 12.2223 5.1297L14.5741 2.8334C13.1297 1.49082 11.25 0.666748 9.00008 0.666748C5.74082 0.666748 2.92601 2.53709 1.55566 5.25928L4.25008 7.35188C4.92606 5.34264 6.79641 3.88893 9.00008 3.88893Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglelogo);
export default __webpack_public_path__ + "static/media/google.logo.4b37e0edf37d286212d4c9aeb569630f.svg";
export { ForwardRef as ReactComponent };